import { useEffect, useState } from "react";
import { Share2, X } from "lucide-react";

const DISMISS_KEY = "datacom.install-prompt.dismissed";

function isIosSafari(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  const isIos = /iPhone|iPad|iPod/.test(ua);
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
  return isIos && isSafari;
}

function isStandalone(): boolean {
  if (typeof window === "undefined") return false;
  const mq = window.matchMedia?.("(display-mode: standalone)").matches;
  // @ts-expect-error iOS Safari only
  const iosStandalone = window.navigator.standalone === true;
  return Boolean(mq) || iosStandalone;
}

export function InstallPromptBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY) === "true") return;
    } catch { /* storage non leggibile: si mostra l'invito */ }
    if (!isIosSafari()) return;
    if (isStandalone()) return;
    // piccolo delay per evitare flicker durante mount iniziale
    const t = window.setTimeout(() => setShow(true), 600);
    return () => window.clearTimeout(t);
  }, []);

  const dismiss = () => {
    setShow(false);
    try {
      localStorage.setItem(DISMISS_KEY, "true");
    } catch { /* storage non disponibile: l'invito tornera' */ }
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Installa l'app sulla schermata Home"
      className="pointer-events-auto mx-3 mb-2 flex items-start gap-3 rounded-md border border-border bg-card p-3 text-sm text-card-foreground shadow-sm"
    >
      <Share2 className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
      <p className="min-w-0 flex-1 leading-snug">
        Installa l'app: tocca l'icona <span className="font-medium">Condividi</span> e poi{" "}
        <span className="font-medium">"Aggiungi a schermata Home"</span>.
      </p>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Chiudi suggerimento installazione"
        className="-mr-1 -mt-1 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}